/* eslint-disable import/no-anonymous-default-export */
import { Navigate } from "react-router-dom";
import { CONFIRM_EMAIL, FORGOT_PASSWORD, RESET_PASSWORD, SIGNIN, EMAIL_VERIFICATION } from "../../constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    index: true,
    element: <Navigate to={SIGNIN} />,
  },
  {
    path: SIGNIN,
    lazy: () => import("./routes/AuthSignin"),
  },
  {
    path: CONFIRM_EMAIL,
    lazy: () => import("./routes/AuthEmailConfirmation"),
  },
  {
    path: RESET_PASSWORD,
    lazy: () => import("./routes/AuthResetPassword"),
  },
  {
    path: FORGOT_PASSWORD,
    lazy: () => import("./routes/AuthForgotPassword"),
  },
  {
    path: EMAIL_VERIFICATION,
    lazy: () => import("./routes/AuthEmailVerification"),
  },
];
